import React, { useState, useEffect } from "react";
import Layout from "../../components/Admin/AdminLayout";
import AdminHeader from "./component/AdminHeader";
import axios from "axios";
import { message } from "antd";

const AddOfflineBooking = () => {
  const [form, setForm] = useState({
    tripName: "",
tripStartDate: "",
tripEndDate: "",
    username: "",
    email: "",
    mobile: "",
    city: "",
    salesAssistant: "",
    totalAmount: "",
    advance: "",
    remainingAmount: "",
travellers: "",   // user will enter number of travellers
    arrival: "",
departure: ""
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
  try {
   const payload = {
  ...form,
  tripDate: `${form.tripStartDate} - ${form.tripEndDate}`,
  occupancy: [
    {
      name: "Total Travellers",
      count: Number(form.travellers),
    },
  ],
};


    const res = await axios.post("/api/booking/add-offline-booking", payload);

    if (res.data.success) {
      message.success("Offline Booking Added");
      window.location.href = "/booking-list";
    } else {
      message.error("Failed to add booking");
    }
  } catch (err) {
    message.error("Server Error");
  }
};

const [trips, setTrips] = useState([]);

useEffect(() => {
  async function loadTrips() {
    try {
      const res = await axios.get("/api/trips/get-all-trips");
      if (res.data.success) {
        setTrips(res.data.data); 
      }
    } catch (err) {
      console.log(err);
    }
  }
  loadTrips();
}, []);

  return (
    <Layout>
      <AdminHeader title="Add Offline Booking" redirect="/booking-list" />

      <div className="container Mon_font mt-4">
        <div className="card p-4">

          <div className="row">
            <div className="col-md-6 mb-3">
              <label>Trip Name</label>
<select
  className="form-control"
  name="tripName"
  value={form.tripName}
  onChange={handleChange}
>
  <option value="">Select Trip</option>

  {trips.map((trip) => (
    <option key={trip._id} value={trip.heading}>
      {trip.heading}
    </option>
  ))}
</select>
            </div>

          <div className="col-md-6 mb-3">
  <label>Trip Start Date</label>
  <input
    type="date"
    className="form-control"
    name="tripStartDate"
    value={form.tripStartDate}
    onChange={handleChange}
  />
</div>

<div className="col-md-6 mb-3">
  <label>Trip End Date</label>
  <input
    type="date"
    className="form-control"
    name="tripEndDate"
    value={form.tripEndDate}
    onChange={handleChange}
  />
</div>


            <div className="col-md-6 mb-3">
              <label>Customer Name</label>
              <input className="form-control" name="username" value={form.username} onChange={handleChange}/>
            </div>

            <div className="col-md-6 mb-3">
              <label>Mobile</label>
              <input className="form-control" name="mobile" value={form.mobile} onChange={handleChange}/>
            </div>

            <div className="col-md-6 mb-3">
              <label>Email</label>
              <input className="form-control" name="email" value={form.email} onChange={handleChange}/>
            </div>

            <div className="col-md-6 mb-3">
              <label>City</label>
              <input className="form-control" name="city" value={form.city} onChange={handleChange}/>
            </div>

            <div className="col-md-6 mb-3">
              <label>Sales Assistant</label>
<select
  className="form-control"
  name="salesAssistant"
  value={form.salesAssistant}
  onChange={handleChange}
>
  <option value="">Select Sales Assistant</option>
  <option value="Aman">Aman</option>
  <option value="Kiran">Kiran</option>
  <option value="Rohit">Rohit</option>
  <option value="Neha">Neha</option>
</select>
            </div>

            <div className="col-md-4 mb-3">
              <label>Total Amount</label>
              <input className="form-control" name="totalAmount" value={form.totalAmount} onChange={handleChange}/>
            </div>

            <div className="col-md-4 mb-3">
              <label>Advance</label>
              <input className="form-control" name="advance" value={form.advance} onChange={handleChange}/>
            </div>

            <div className="col-md-4 mb-3">
              <label>Remaining</label>
              <input className="form-control" name="remainingAmount" value={form.remainingAmount} onChange={handleChange}/>
            </div>
            <div className="col-md-4 mb-3">
  <label>Total Travellers</label>
 <input
  type="number"
  className="form-control"
  name="travellers"
  value={form.travellers}
  onChange={handleChange}
/>

</div>

<div className="col-md-4 mb-3">
  <label>Departure</label>
  <input
    className="form-control"
    name="departure"
    value={form.departure}
    onChange={handleChange}
  />
</div>

<div className="col-md-4 mb-3">
  <label>Arrival</label>
  <input
    className="form-control"
    name="arrival"
    value={form.arrival}
    onChange={handleChange}
  />
</div>

          </div>

          <button className="btn btn-success mt-3" onClick={handleSubmit}>
            Save Booking
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default AddOfflineBooking;
